import SseHub from './SseHub.js';

// Cliente SSE del /proponer asíncrono (ENCARGO-021c). Canal `proponer-planificacion` (per-user, no
// difusión: el hub NO reenvía el último al reconectar — por diseño de seguridad; ver SseHubService
// en el backend). El sobre viaja SIEMPRE con `pasadaId`; los suscriptores tienen que filtrar por él
// y descartar cualquier evento sin él o con un `pasadaId` distinto (dos corridas idénticas del
// mismo inspector generarían `runId` iguales; el `pasadaId` es UUID y garantiza que lo pintado
// corresponde a ESTA pasada, no a otra vieja que llegue tarde por reintento del hub).
//
// Fases (mismos strings del backend, definidos en ProponerJobService):
//   EN_COLA → CONSTRUYENDO → RESOLVIENDO → MAPEANDO → FIN | ERROR
//
// Uso desde la vista:
//   const off = ProponerPlanificacionEvents.subscribe('<pasadaId>', function (payload) { ... });
//   // ... más tarde:
//   off();  // desengancha ESE listener sin cerrar el canal del hub.
//
// Con `pasadaId` nulo el suscriptor recibe TODOS los eventos (útil sobre todo para diagnóstico);
// en producción cada vista pasa su pasadaId.

const CANAL = 'proponer-planificacion';

// listeners: [{ pasadaId, cb }]
const listeners = [];
let enganchado = false;

function notificar(payload) {
    if (!payload || typeof payload !== 'object') return;
    // Filtro DURO por pasadaId — descartar cualquier sobre sin él evita repintar el drawer con
    // eventos que se cuelen entre corridas (dos pasadas seguidas del mismo inspector podrían
    // compartir runId pero NUNCA pasadaId).
    const pid = payload.pasadaId;
    if (!pid) return;
    listeners.slice().forEach(function (l) {
        if (l.pasadaId != null && l.pasadaId !== pid) return;
        try { l.cb(payload); } catch (err) {
            console.error('[ProponerPlanificacionEvents] suscriptor lanzó', err);
        }
    });
}

function ensureConnected() {
    if (enganchado) return;
    enganchado = true;
    SseHub.subscribe(CANAL, notificar);
}

export default {
    /**
     * Suscribe un callback a la narración de UNA pasada concreta. Devuelve una función `off()`
     * que la desengancha; no cierra el canal del hub (comparto la conexión con el resto de
     * pantallas). Si `pasadaId` es null, recibe todo.
     */
    subscribe(pasadaId, callback) {
        if (typeof callback !== 'function') return function () {};
        const entrada = { pasadaId: pasadaId || null, cb: callback };
        listeners.push(entrada);
        ensureConnected();
        return function () {
            const i = listeners.indexOf(entrada);
            if (i >= 0) listeners.splice(i, 1);
        };
    },
    /** Fases canónicas expuestas como constantes (evita typos en los switch de las vistas). */
    FASES: {
        EN_COLA: 'EN_COLA',
        CONSTRUYENDO: 'CONSTRUYENDO',
        RESOLVIENDO: 'RESOLVIENDO',
        MAPEANDO: 'MAPEANDO',
        FIN: 'FIN',
        ERROR: 'ERROR'
    },
    CANAL: CANAL
};
